import * as B from '@blueprintjs/core';
import React from 'react';

export const CONTACT_EMAIL = 'lens@upstream.tech';

export const contactMailtoUrl = (emailSubject: string, emailBody: string) =>
  `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(
    emailSubject
  )}&body=${encodeURIComponent(emailBody)}`;

interface Props {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  message: string;
  emailSubject: string;
  emailBody: string;
}

const AgentContactDialog: React.FC<Props> = ({
  isOpen,
  onClose,
  title,
  message,
  emailSubject,
  emailBody,
}) => {
  const mailtoUrl = contactMailtoUrl(emailSubject, emailBody);

  return (
    <B.Dialog isOpen={isOpen} onClose={onClose} title={title}>
      <B.DialogBody>
        <p>
          {message} Reach out to us at <a href={mailtoUrl}>{CONTACT_EMAIL}</a>.
        </p>
      </B.DialogBody>
    </B.Dialog>
  );
};

export default AgentContactDialog;
